








































































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import HelpTooltip from '@front-app/components/dropdowns/HelpTooltip.vue';
import HelpTooltipBlock from '@front-app/components/dropdowns/HelpTooltipBlock.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { GroupAccessMode, GroupAccessSettings } from '@front-app/services/GroupsApi/GroupAccessSettingsModel';
import { GroupWithCommunity } from '@front-app/services/GroupsApi/GroupModel';
import { requiredIfBoth } from '@front-app/components/form/validation/validators';
import { Size, Spacing } from '@front-app/components/constants';
import { syncedRef } from '@front-app/util/reactivity';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { useGroupAccessStore } from '@front-app/store/piniaModules/groupAccess';
import { v } from '@front-app/components/form/validation/useValidation';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		FormError,
		FormInput,
		HelpTooltip,
		HelpTooltipBlock,
		SimpleCard,
		SuccessCard,
		TrCheckbox,
		TrForm,
	},
	props: {
		group: {
			type: Object as PropType<GroupWithCommunity>,
			required: true,
		},
	},
	setup(props) {
		const accessSettings = computed(() => {
			if (!props.group.accessSettings) {
				throw Error('Access settings are missing.');
			}
			return props.group.accessSettings;
		});
		const accessMode = syncedRef(() => accessSettings.value.accessMode).ref;
		const restrictEmailDomain = syncedRef(() => accessSettings.value.restrictEmailDomain).ref;
		const emailDomain = syncedRef(() => accessSettings.value.emailDomain).ref;

		// Uncheck mutually-exclusive checkboxes on toggle
		const toggleAccessMode = () => {
			if (accessMode.value === GroupAccessMode.OPEN) {
				accessMode.value = GroupAccessMode.INVITE_ONLY;
			} else {
				accessMode.value = GroupAccessMode.OPEN;
				restrictEmailDomain.value = false;
			}
		};

		const validation = v({
			emailDomain: {
				value: emailDomain,
				rules: [requiredIfBoth(() => restrictEmailDomain.value)],
			},
		});
		const { focusFirstInvalid } = useFocusFirstInvalidField({ containerSelector: '#group-access-form' });

		// Submission
		const {
			track,
			isError,
			isLoading,
			isSuccess,
		} = useAsyncStatus();
		const changeAccess = async () => {
			if (!restrictEmailDomain.value) {
				emailDomain.value = '';
			}
			// Validate if the email domain is put in if the corresponding box is checked
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}
			const payload: GroupAccessSettings = {
				accessMode: accessMode.value,
				professionalsOnly: accessMode.value === GroupAccessMode.INVITE_ONLY ? false : accessSettings.value.professionalsOnly,
				restrictEmailDomain: restrictEmailDomain.value,
				emailDomain: accessMode.value === GroupAccessMode.OPEN ? '' : emailDomain.value,
				termsOfUse: accessSettings.value.termsOfUse,
				enableAccessCodes: accessSettings.value.enableAccessCodes,
				sharePersonalInformation: accessSettings.value.sharePersonalInformation,
				paidEntry: accessSettings.value.paidEntry,
				joinOnFirstAccess: accessSettings.value.joinOnFirstAccess,
			};

			await track(useGroupAccessStore().changeGroupAccess(props.group.id, payload));
		};
		// END Submission

		return {
			GroupAccessMode,
			accessMode,
			restrictEmailDomain,
			emailDomain,
			validation,
			toggleAccessMode,
			// Submission
			changeAccess,
			isError,
			isLoading,
			isSuccess,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
